import * as React from 'react';
import * as ReactDOM from 'react-dom';


import { getProductInformation, ProductInformation } from './ProductInformationWrapper';
import StickyPurchaseButtons from './StickyPurchaseButtons';
import AddToCartBtn, { CartProduct } from './AddToCartBtn';
import BuyNowBtn from './BuyNowBtn';
import { Button } from '@bepure/tarkin';
import { BUTTON_TYPE } from '@bepure/tarkin';



interface productSellerProps {
    sku: string
    product: ProductInformation;
}


const backButtonHandler = () => {
    window.location.href = "../" ;
}


const ProductSeller = (props: productSellerProps) => {

    const quantity = props.product.customFields.edges.find(obj => obj.node.name === 'supplyValue')?.node.value
        const cartProduct: CartProduct = {
            name: props.product.name,
            unit_price: props.product.prices.price.value,
            sku: props.sku,
            imageUrl: props.product.imageUrl,
            id: props.product.entityId,
        }

    return (
        <div>
            <StickyPurchaseButtons>
                <AddToCartBtn product={cartProduct} sku={props.sku} otherClasses={'btn--secondary--full'}/>
                <BuyNowBtn product={cartProduct} sku={props.sku} buttonType={BUTTON_TYPE.SECONDARY} />
            </StickyPurchaseButtons>
            <div className="product-seller"
                style={{
                    width: '100%',
                }}>
            
                <Button className="product-seller-back-arrow"ariaLabel="back-button-arrow" icon="west" text="back" otherClasses={'btn-black-back'} onClick={backButtonHandler}></Button>
                <div className="product-seller-panel">
                    <div className="left-part">
                        <img className="product-seller-image" src={props.product.imageUrl}></img>
                    </div>
                    <div className="right-part">
                        <div className="product-seller-title">
                            <span>{props.product.name}</span>
                        </div>
                        <div className="product-seller-price-container">
                            <span className="product-seller-price">{"$" + props.product.prices.price.value}</span>
                            <span className="product-seller-quantity">{quantity}</span>
                        </div>
            
                        <div className="product-seller-buttons">
                            <AddToCartBtn product={cartProduct} sku={props.sku} otherClasses={'btn--secondary--full product-seller-addtocart'} />
                            <div className="product-seller-spacing"></div>
                            <BuyNowBtn product={cartProduct} sku={props.sku} otherClasses={'product-seller-buynow'}/>
                        </div>
                    </div>
                </div>
            
            </div>
        </div>
    )
}

export default function render() {
    const elements = document.getElementsByClassName('product-seller-box');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const productSku = element.dataset.productSku || '';
        getProductInformation(productSku).then((productInfo: ProductInformation) => {
            return ReactDOM.render(
                <ProductSeller sku={productSku} product={productInfo} />,
                
                element
            )
        })
    })
}


